import React from "react";
import { createRoot } from "react-dom/client";
import { Marketplace } from "../../../packages/client/src/Marketplace";
import "../../../packages/client/src/styles.css";
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Marketplace
      kind="storefront"
      origin={import.meta.env.VITE_API_ORIGIN || window.location.origin}
    />
  </React.StrictMode>,
);
